import type { QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class FiveSecTestApi extends QuestionSimpleApi {
    public query() {
        return {} as AnswersRequest;
    }

    public validate(question: QuestionContext): boolean {
        const { responseActor } = question;
        const response = responseActor.getSnapshot().context;

        return Boolean(response.value);
    }
}
